import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { DeviceTokenModel } from "@modules/api/device-token-model.generated";
import { UserSession } from "@modules/api/user-session.generated";
import { DeviceTokenService } from "@modules/common/services/device-token.service";
import { RedirectToLoginService } from "@modules/common/services/redirect-to-login.service";
import { UserSessionService } from "@modules/common/services/user-session.service";

@Injectable({
    providedIn: 'root'
})
export class CompleteLoginService {
    constructor(
        private _userSessionService: UserSessionService,
        private _redirectToLoginService: RedirectToLoginService,
        private _deviceTokenService: DeviceTokenService,
        private _router: Router
    ) { }

    public completeLogin(args: { userSession?: UserSession, deviceToken?: DeviceTokenModel, redirectHTML?: string }): void {
        this.setDeviceTokenIfAvailable(args.deviceToken);

        if (args.userSession) {
            this._userSessionService.setUserSession(args.userSession);

            if (this._redirectToLoginService.getRedirectedFromUrl()) {
                this._router.navigate(this._redirectToLoginService.getRedirectedFromUrl()!, { queryParams: this._redirectToLoginService.getQueryParams() });
                this._redirectToLoginService.clearRedirectedFromUrl();
            } else if (args.userSession.restrictedToCase) {
				this._router.navigate([(this.getEnvironment(args.userSession) ? '/' + this.getEnvironment(args.userSession) : '') + '/' + args.userSession.restrictedToCase.code + '/Dashboards']);
            } else {
                this._router.navigate(['/' + this.getEnvironment(args.userSession)]);
            }
        } else if (args.redirectHTML) {
            window.document.body.innerHTML = args.redirectHTML;
            window.document.forms[0].submit();
        }
    }

    private getEnvironment(userSession: UserSession): string {
        const defaultEnvironment = userSession.allowedEnvironments && userSession.allowedEnvironments.filter(x => x.isDefault)[0];
        return defaultEnvironment && defaultEnvironment.name || '';
    }

    private setDeviceTokenIfAvailable(deviceToken?: DeviceTokenModel): void {
        if (deviceToken && deviceToken.id && deviceToken.token) {
            this._deviceTokenService.setDeviceToken({
                id: deviceToken.id,
                token: deviceToken.token
            });
        }
    }
}
